<ion-nav [class]="productCategory" [root]="rootPage" [rootParams]="rootParams" [swipeGesture]="false"></ion-nav>
